<template>
    <component @remove="remove" :is="component" :data="data" v-if="component" />
</template>

<script>
    import camelCase from 'lodash/camelCase'
    import upperFirst from 'lodash/upperFirst'

    export default {
        name: 'NotificationLoader',
        props: {
            data: {
                type: Object,
                required: true,
            },
            type: {
                type: String,
                required: true,
            },
        },
        data () {
            return {
                component: null,
            }
        },
        computed: {
            loader () {
                return () => {
                    const type = upperFirst(camelCase(this.type));
                    return import(`./Types/${type}`);
                }
            },
        },
        methods: {
            remove (id) {
                this.$emit('remove', id);
            },
        },
        mounted () {
            this.loader()
                .then(() => {
                    this.component = () => this.loader()
                });
        },
    }
</script>
